export default __webpack_public_path__ + "static/media/q-contactUS.1cb5e604.png";